import styled from "styled-components";

export const Title = styled.h2`
   font-size: 36px;
   font-weight: 700;
   line-height: 50px;
   text-align: center;
   color: #2A2637;
   margin-bottom: 48px;
   margin-top: 84px;
   @media(max-width: 600px) {
     text-align: left;
     line-height: 33px;
     margin-bottom: 32px;
     margin-top: 48px;
   }  
`

export const Container = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   @media(max-width: 600px) {
     align-items: flex-start ;
   }
   @media(max-width: 1100px) {
     padding: 0 15px;
   } 
`

export const Block = styled.div`
  display: flex;
  width: 374px;
  margin-bottom: 48px;
  @media(max-width: 600px) {
     width: 312px;
  }  
`

export const Line = styled.div`
   width: 8px;
   height: 147px;
   border-radius: 20px;
   background-color: #CFEFF8;
   margin-right: 28px;
   @media(max-width: 768px) {
     height: 127px;
   }
`

export const Line2 = styled.div`
   width: 8px;
   height: 176px;
   border-radius: 20px;
   background-color: #CFEFF8;
   margin-right: 28px;
   @media(max-width: 768px) {
     height: 149px;
   }   
`

export const BlockContent = styled.div`
 width: 374px;
`

export const TitleBlock = styled.div`
   font-size: 20px;
   font-weight: 700;
   line-height: 28px;
   color: #2A2637;
   margin-bottom: 16px;
   @media(max-width: 768px) {
     font-size: 18px;
   }
`

export const Text = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 29px;
  color: #4E4963;
  @media(max-width: 768px) {
     font-size: 14px;
     line-height: 22.4px;
  }
`

export const Btn = styled.div`
  margin-top: 16px;
`

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const Content = styled.div`
  margin-right: 64px;
`
